import {
  Typography,
  TypographyColors,
  TypographyVariants
} from "@certa/catalyst/components/Typography";
import { Stack } from "@certa/catalyst/layouts/Stack";
import { leftPanelStyles } from "./LeftPanel.styles";
import { Switch } from "@certa/catalyst/components/Switch";
import { Tooltip } from "@certa/catalyst/components/Tooltip";
import { Info } from "@certa/icons/components/Info";
import { useIntl } from "react-intl";

type FieldCategoryProps = {
  title: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  shouldDisableSelection?: boolean;
  shouldShowBorder?: boolean;
};
const FieldCategory = ({
  title,
  checked,
  onChange,
  shouldDisableSelection,
  shouldShowBorder
}: FieldCategoryProps) => {
  const intl = useIntl();

  const tooltipLabel = intl.formatMessage({
    id: "globalSearch.fieldCategory.tooltip",
    defaultMessage:
      "Turn on to include workflow and data record field data (eg. DUNS number, POC Email) in search"
  });

  return (
    <Stack
      gap="8"
      padding="8 0"
      dangerouslySetClassName={leftPanelStyles.category(shouldShowBorder)}
      direction="horizontal"
      align="center"
    >
      <Stack
        direction="horizontal"
        gap="8"
        dangerouslySetClassName={leftPanelStyles.flexGrow}
        align="center"
      >
        <Typography
          variant={TypographyVariants.LABEL_SM}
          color={TypographyColors.NEUTRAL_700}
        >
          {title}
        </Typography>
        <Tooltip content={tooltipLabel} hideTooltipFromScreenReaders>
          <Info size={12} color={TypographyColors.NEUTRAL_700} />
        </Tooltip>
      </Stack>
      <Switch
        checked={checked}
        label={title}
        onChange={onChange}
        disabled={shouldDisableSelection}
      />
    </Stack>
  );
};

export { FieldCategory };
